var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * @Author: freedeng
 * @Date: 2019-07-19 10:02:20
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-07-19 17:17:51
 */
var Strategy;
(function (Strategy) {
    Strategy[Strategy["ONCE"] = 0] = "ONCE";
    Strategy[Strategy["RETRY"] = 1] = "RETRY";
})(Strategy || (Strategy = {}));
var MutexLock = /** @class */ (function () {
    function MutexLock(config) {
        this.tabId = this.getTabID();
        if (!config) {
            config = this.getDefaultConfig();
        }
        else {
            config = __assign(__assign({}, this.getDefaultConfig()), config);
        }
        this.strategy = config.strategy;
        this.period = config.period;
        this.autoRenewal = config.autoRenewal;
    }
    MutexLock.prototype.getTabID = function () {
        var date = new Date();
        return 1 + date.getMonth() + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + ":" + date.getMilliseconds() + " " + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    };
    /**
     * 续期
     * @param key
     */
    MutexLock.prototype.renewal = function (key, period) {
    };
    MutexLock.DEBUG = false;
    MutexLock.DEFAULT_CONFIG = {
        strategy: Strategy.ONCE,
        period: 5 * 60 * 1000,
        autoRenewal: true,
    };
    MutexLock.renewalHanlder = new Map(); // 自动续期setTimeout句柄 用于取消自动续期
    return MutexLock;
}());
export { MutexLock, Strategy as LockStrategy, };
//# sourceMappingURL=MutexLock.js.map